import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { createTheme } from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { store, customStoreFunctions } from './store';
import { ToastContainer } from 'react-toastify';
import rootSaga from 'store/sagas';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'leaflet/dist/leaflet.css';

function init() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  const theme = createTheme();

  customStoreFunctions.runSaga(rootSaga);
  root.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>,
  );
}
init();
